import { render, staticRenderFns } from "./BrTeamAssessModal.vue?vue&type=template&id=3530097e&scoped=true"
import script from "./BrTeamAssessModal.vue?vue&type=script&lang=js"
export * from "./BrTeamAssessModal.vue?vue&type=script&lang=js"
import style0 from "./BrTeamAssessModal.vue?vue&type=style&index=0&id=3530097e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3530097e",
  null
  
)

export default component.exports